import { IdentifiersMap } from './identifiers-map.interface';

export interface ApiParamEnabled {
	getApiParamPortfolio(): ApiParamPortfolio;
}

export interface ApiParamPosition {
	getWeight(): number;
}

export class ApiParamPortfolio {
	constructor(
		public readonly id: string,
		public readonly positions: ApiParamPosition[],
		public readonly type?: string,
		public readonly currency?: string
	) { }
}

export class ApiParamPositionImpl implements ApiParamPosition {
	constructor(
		public readonly identifier: string,
		public readonly identifierType: string,
		public readonly weight: number,
		public readonly positionType?: string,
		public readonly value?: number) { }

	public getValue(): number {
		return this.value;
	}
	public getWeight(): number {
		return this.weight;
	}
	public getIdentifier(): string {
		return this.identifier;
	}
	public getIdentifierType(): string {
		return this.identifierType;
	}
}

export class WweApiParamPositionImpl implements ApiParamPosition {
	constructor(
		public readonly id: string,
		public readonly identifiers: IdentifiersMap,
		public readonly weight: number,
		public readonly value?: number) { }

	public getId(): string {
		return this.id;
	}
	public getIdentifiers(): IdentifiersMap {
		return this.identifiers;
	}
	public getWeight(): number {
		return this.weight;
	}
	public getValue(): number {
		return this.value;
	}
}

export interface ApiParamRule {
	benchmarkThresholdLow?: number;
	benchmarkThresholdHigh?: number;
	evalThresholdLow?: number;
	evalThresholdHigh?: number;
}

export interface ApiParamFundStatus {
	statusId: string;
	statusIdToShow: string;
	description: string;
	aofs?: ApiParamFundAreaOfFocus[]; // optional for green status
}

export interface ApiParamFundAreaOfFocus {
	aofId: string;
	aofIdToShow: string;
	subAofIds: string[];
	description: string;
	dimension: string;
}
